import { Datoblock } from "./Types";

export interface PrivacyQueryResponse {
    roadside?: {
        personalDetailsAlertBoxInfo: Datoblock;
    };
}

export const PrivacyQuery = `
{
    roadside {
        personalDetailsAlertBoxInfo {
          blocks
          links
          value
        }
    }
}
`;
